import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { Helpers } from 'src/app/model';
import { ReportAnIssueModalComponent } from '../../modals/report-an-issue-modal/report-an-issue-modal.component';
import { ReportedIssue } from '../../models/reported-issue';
import { HttpService } from '../../services/http-service.service';

@Component({
  selector: 'app-report-an-issue',
  templateUrl: './report-an-issue.component.html',
  styleUrls: ['./report-an-issue.component.css']
})
export class ReportAnIssueComponent implements OnInit {
  modalRef: BsModalRef;
  reportedIssueObj : ReportedIssue
  constructor(private modalService: BsModalService, httpService : HttpService) { }

  ngOnInit(): void {
  }
  reportAnIssue(): void {
    this.modalRef = this.modalService.show(ReportAnIssueModalComponent, Helpers.getModalConfig());
    this.modalRef.setClass('draggable-modal')

  }
}
